import type { IApiClientConfig } from "../services/AxiosApiClientInstance/dtos/AxiosApiClientConfig";

export function getAxiosPyrgosConfig(version: string = "v1"): IApiClientConfig {
  return {
    baseURL: `${process.env.REACT_APP_PYRGOS_URL}/pyrgos/${version}`,
    withCredentials: true,
  };
}
